export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: '海角论坛是什么？',
    answer: '海角论坛是一个综合性的中文网络社区平台，涵盖技术交流、生活杂谈、影视娱乐、游戏电竞、学习资料等多个版块。用户可以在论坛上自由发帖、回复、分享内容，与来自全国各地的网友交流互动。',
  },
  {
    question: '如何注册海角论坛账号？',
    answer: '注册非常简单！访问海角论坛官网首页，点击右上角的"注册"按钮，输入您的手机号或邮箱地址，设置密码和昵称，完成验证后即可成功注册。整个过程只需1-2分钟。',
  },
  {
    question: '海角论坛的登录入口在哪里？',
    answer: '您可以通过海角论坛官网首页的"登录"按钮进入登录页面。也可以直接将海角论坛最新地址添加到浏览器收藏夹，方便下次快速访问。',
  },
  {
    question: '海角论坛最新地址是什么？',
    answer: '海角论坛的官方网址建议通过搜索引擎搜索"海角论坛官网"获取最新地址。建议收藏官方网址并关注官方公告，以防遇到仿冒网站。',
  },
  {
    question: '海角论坛有哪些热门版块？',
    answer: '海角论坛目前拥有八大热门版块：技术交流、生活杂谈、影视娱乐、游戏电竞、学习资料、灌水乐园、摄影美图和音乐分享。每个版块都有大量优质内容和活跃用户。',
  },
  {
    question: '如何在海角论坛发布帖子？',
    answer: '登录账号后，进入您感兴趣的版块，点击"发帖"按钮即可编写帖子。支持文字、图片、链接等多种内容格式。发布前请注意遵守各版块的发帖规范。',
  },
  {
    question: '海角论坛账号安全问题如何保障？',
    answer: '海角论坛采用多重安全保护措施，包括SSL加密传输、账号异常登录检测、手机验证等。建议您设置强密码并绑定手机号/邮箱，开启两步验证功能，保护好个人账号安全。',
  },
  {
    question: '海角论坛有手机App吗？',
    answer: '海角论坛目前主要以网页版为主，同时提供适配移动端的响应式页面，在手机浏览器中访问即可获得良好的浏览体验。移动端App正在开发中，敬请期待。',
  },
];